import { useEffect, useState } from "react";
import api from "../lib/api";
import { Search, Plus, Trash2, Sparkles, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function SpyConcurrence() {
  const [list, setList] = useState([]);
  const [form, setForm] = useState({ handle: "", platform: "instagram", niche: "", followers: 0, avg_views: 0, top_hook: "", notes: "" });
  const [showForm, setShowForm] = useState(false);
  const [target, setTarget] = useState({ handle: "", platform: "instagram", niche: "" });
  const [analysis, setAnalysis] = useState("");
  const [loading, setLoading] = useState(false);

  const load = async () => setList(await api.listCompetitors());
  useEffect(() => { load(); }, []);

  const submit = async (e) => {
    e.preventDefault();
    await api.createCompetitor(form);
    toast.success("Concurrent ajouté");
    setShowForm(false);
    setForm({ handle: "", platform: "instagram", niche: "", followers: 0, avg_views: 0, top_hook: "", notes: "" });
    load();
  };

  const spyAi = async () => {
    if (!target.handle) return toast.error("Handle requis");
    setLoading(true); setAnalysis("");
    try {
      const r = await api.aiSpy({ prompt: target.handle, platform: target.platform, niche: target.niche });
      setAnalysis(r.analysis || "");
    } catch { toast.error("Erreur IA"); }
    finally { setLoading(false); }
  };

  return (
    <div className="space-y-8 animate-fadeUp" data-testid="spy-page">
      <header className="flex items-end justify-between flex-wrap gap-4">
        <div className="border-l-2 border-[#CCFF00] pl-5">
          <div className="text-[10px] font-mono uppercase tracking-[0.2em] text-[#CCFF00] mb-2">// SPY CONCURRENCE</div>
          <h1 className="font-display text-4xl sm:text-5xl font-bold text-white tracking-tight">Espionnage stratégique</h1>
          <p className="text-zinc-400 mt-2">Track tes concurrents. Analyse leurs hooks. Vole intelligemment.</p>
        </div>
        <button onClick={() => setShowForm(s => !s)} data-testid="add-comp-btn"
          className="bg-[#CCFF00] text-black font-medium px-5 py-2.5 rounded-sm hover:bg-[#B3E600] flex items-center gap-2 text-sm">
          <Plus className="w-4 h-4" /> Ajouter
        </button>
      </header>

      <div className="border border-[#00D4FF]/30 bg-[#00D4FF]/[0.02] rounded-sm p-6 space-y-4">
        <div className="flex items-center gap-2">
          <Sparkles className="w-5 h-5 text-[#00D4FF]" strokeWidth={1.5} />
          <h2 className="font-display text-xl font-semibold text-white">Analyse IA d'un concurrent</h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          <input value={target.handle} onChange={e => setTarget({ ...target, handle: e.target.value })}
            placeholder="@handle" data-testid="spy-handle"
            className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white" />
          <select value={target.platform} onChange={e => setTarget({ ...target, platform: e.target.value })}
            className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white">
            <option value="instagram">Instagram</option><option value="tiktok">TikTok</option>
            <option value="youtube">YouTube</option><option value="x">X</option>
          </select>
          <input value={target.niche} onChange={e => setTarget({ ...target, niche: e.target.value })}
            placeholder="Niche" className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white" />
        </div>
        <button onClick={spyAi} disabled={loading} data-testid="spy-analyze-btn"
          className="bg-[#00D4FF]/10 border border-[#00D4FF]/40 text-[#00D4FF] hover:bg-[#00D4FF]/20 px-4 py-2 rounded-sm text-sm font-mono uppercase tracking-wider flex items-center gap-2">
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Search className="w-4 h-4" />}
          Lancer l'analyse
        </button>
        {analysis && (
          <div className="border-t border-[#1E1E24] pt-4 text-sm text-zinc-200 whitespace-pre-line leading-relaxed" data-testid="spy-result">{analysis}</div>
        )}
      </div>

      {showForm && (
        <form onSubmit={submit} className="border border-[#1E1E24] bg-[#0A0A0C] rounded-sm p-6 grid grid-cols-1 md:grid-cols-3 gap-3" data-testid="comp-form">
          <input required placeholder="@handle" value={form.handle} onChange={e => setForm({ ...form, handle: e.target.value })} className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white" />
          <select value={form.platform} onChange={e => setForm({ ...form, platform: e.target.value })} className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white">
            <option value="instagram">Instagram</option><option value="tiktok">TikTok</option>
            <option value="youtube">YouTube</option><option value="x">X</option>
          </select>
          <input placeholder="Niche" value={form.niche} onChange={e => setForm({ ...form, niche: e.target.value })} className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white" />
          <input type="number" placeholder="Followers" value={form.followers} onChange={e => setForm({ ...form, followers: +e.target.value })} className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white" />
          <input type="number" placeholder="Vues moy." value={form.avg_views} onChange={e => setForm({ ...form, avg_views: +e.target.value })} className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white" />
          <input placeholder="Top hook" value={form.top_hook} onChange={e => setForm({ ...form, top_hook: e.target.value })} className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white" />
          <textarea placeholder="Notes" value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} rows={2} className="bg-[#0C0C0E] border border-[#1E1E24] rounded-sm px-3 py-2 text-sm text-white md:col-span-3" />
          <button type="submit" data-testid="submit-comp" className="bg-[#CCFF00] text-black px-5 py-2 rounded-sm font-medium text-sm md:col-span-3">Enregistrer</button>
        </form>
      )}

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {list.map(c => (
          <div key={c.id} className="border border-[#1E1E24] bg-[#0A0A0C] rounded-sm p-5 hover:border-white/20 transition" data-testid={`comp-${c.handle}`}>
            <div className="flex items-start justify-between mb-3">
              <div>
                <div className="font-mono text-[#CCFF00] text-base">{c.handle}</div>
                <div className="text-[11px] font-mono uppercase tracking-wider text-zinc-500 mt-1">{c.platform} · {c.niche}</div>
              </div>
              <button onClick={async () => { await api.deleteCompetitor(c.id); load(); }} className="text-zinc-600 hover:text-red-500"><Trash2 className="w-4 h-4" /></button>
            </div>
            <div className="grid grid-cols-2 gap-3 text-sm">
              <div><span className="text-[10px] font-mono uppercase text-zinc-500 block">Followers</span><span className="font-mono text-white">{c.followers.toLocaleString("fr-FR")}</span></div>
              <div><span className="text-[10px] font-mono uppercase text-zinc-500 block">Vues moy.</span><span className="font-mono text-white">{c.avg_views.toLocaleString("fr-FR")}</span></div>
            </div>
            {c.top_hook && <div className="mt-3 border-l-2 border-[#CCFF00] pl-3 text-sm text-white italic">"{c.top_hook}"</div>}
            {c.notes && <div className="mt-2 text-xs text-zinc-400">{c.notes}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
